var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import styles from './inline-input.module.scss';
let InlineInput = class InlineInput extends React.Component {
    constructor(props) {
        super(props);
        this._editing = false;
        this._invalid = false;
        this.onKeyDown = this.onKeyDown.bind(this);
        this.stopPropagation = this.stopPropagation.bind(this);
    }
    startEditing(event) {
        event.stopPropagation();
        this._editing = true;
    }
    finishEditing() {
        if (this._elem) {
            if (!this._invalid) {
                this.props.onCommit(this._elem.value);
                this._editing = false;
            }
        }
    }
    cancelEditing() {
        this._editing = false;
        this._invalid = false;
    }
    validate() {
        if (this._elem) {
            if (this.props.validate) {
                if (this.props.validate instanceof RegExp) {
                    this._invalid = this.props.validate.exec(this._elem.value) === null;
                }
                else {
                    this._invalid = !this.props.validate(this._elem.value);
                }
            }
        }
    }
    onKeyDown(event) {
        event.stopPropagation();
        if (event.keyCode === 13) {
            // "enter"
            this.finishEditing();
        }
        else if (event.keyCode === 27) {
            // "esc"
            this.cancelEditing();
        }
    }
    stopPropagation(event) {
        event.stopPropagation();
    }
    componentDidUpdate() {
        if (this._editing && this._elem) {
            this._elem.focus();
        }
    }
    render() {
        const { className, value } = this.props;
        if (this._editing) {
            const style = this._invalid
                ? { backgroundColor: 'rgba(255, 0, 0, 0.2)' }
                : { backgroundColor: 'inherit' };
            return (React.createElement("input", { className: cx(styles.editable, className), ref: (elem) => this._elem = elem, type: "text", defaultValue: value, onKeyDown: this.onKeyDown, onChange: this.validate, onMouseDown: this.stopPropagation, onClick: this.stopPropagation, onDoubleClick: this.stopPropagation, onBlur: this.cancelEditing, style: style }));
        }
        // render input as span when not editing
        return (React.createElement("span", { className: cx(styles.static, className), onClick: this.startEditing, onDoubleClick: this.stopPropagation }, this.props.value));
    }
};
__decorate([
    observable,
    __metadata("design:type", Boolean)
], InlineInput.prototype, "_editing", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], InlineInput.prototype, "_invalid", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_a = typeof React !== "undefined" && React.MouseEvent) === "function" ? _a : Object]),
    __metadata("design:returntype", void 0)
], InlineInput.prototype, "startEditing", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], InlineInput.prototype, "finishEditing", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], InlineInput.prototype, "cancelEditing", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], InlineInput.prototype, "validate", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof React !== "undefined" && React.KeyboardEvent) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], InlineInput.prototype, "onKeyDown", null);
InlineInput = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], InlineInput);
export default InlineInput;
